import React from 'react';
import { Modal, Box, Typography, TextField, Button } from '@mui/material';
import * as s from '../styles/gitStyles';
import TokenInstructions from '../../../components/TokenInstructions';

export interface GitLoginModalProps {
  open: boolean;
  onClose: () => void;
  isAuthenticated: boolean;
  savedAccessToken: string;
  accessToken: string;
  setAccessToken: (v: string) => void;
  onLogin: () => void;
  onLogout: () => void;
}

export function GitLoginModal({
  open,
  onClose,
  isAuthenticated,
  savedAccessToken,
  accessToken,
  setAccessToken,
  onLogin,
  onLogout,
}: GitLoginModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="login-modal-title"
      aria-describedby="login-modal-description"
    >
      <Box sx={s.modalBox}>
        <Typography id="login-modal-title" variant="h6" component="h2" gutterBottom>
          Авторизация в Git
        </Typography>

        {isAuthenticated ? (
          <>
            <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 2 }}>
              Токен уже установлен. Для изменения токена сначала удалите текущий.
            </Typography>
            <Box sx={s.tokenActiveBox}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Токен активен
              </Typography>
              <Typography variant="caption">
                Последние 4 символа: ***{savedAccessToken?.slice(-4) ?? ''}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
              <Button variant="outlined" onClick={onClose}>
                Закрыть
              </Button>
              <Button variant="contained" color="error" onClick={onLogout}>
                Удалить токен
              </Button>
            </Box>
          </>
        ) : (
          <>
            <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 2 }}>
              Введите ваш Personal Access Token для доступа к Git репозиторию
            </Typography>
            <TextField
              label="Access Token"
              type="password"
              variant="outlined"
              fullWidth
              value={accessToken}
              onChange={(e) => setAccessToken(e.target.value)}
              placeholder="ghp_xxxxxxxxxxxxxxxxxxxx"
              helperText="Personal Access Token из настроек вашего Git-хостинга"
              sx={{ marginBottom: 2 }}
            />

            <Box sx={{ marginBottom: 3 }}>
              <TokenInstructions
                steps={[
                  'Откройте настройки вашего Git-хостинга (GitHub, GitLab, Bitbucket и т. п.).',
                  'Перейдите в раздел управления токенами доступа (обычно «Settings» → «Access Tokens» / «Developer settings» → «Personal access tokens»).',
                  'Создайте новый токен и выдайте ему права на чтение репозиториев (scope вида «repo» / «read_repository»).',
                  'Скопируйте сгенерированный токен — он показывается только один раз — и вставьте его в поле «Access Token».',
                ]}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
              <Button variant="outlined" onClick={onClose}>
                Отмена
              </Button>
              <Button variant="contained" onClick={onLogin}>
                Установить
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
}
